import { connect } from "react-redux";
import PropTypes from "prop-types";
import { browserPropType } from "components/propTypes";
import { displayModal } from "actions/shared-actions";
import ClosableModal from "components/source/shared/closable-modal";
import AtomFullWidthButton from "components/source/atoms/atom-full-width-button";
import { User } from "routes";
import StarOutline from "images/star-outline.svg";
import TapeMeasureOutline from "images/tape-measure-outline.svg";
import DataPlotOutline from "images/data-plot-outline.svg";
import { renderImportedImage } from "helpers/storefront-next-transition-helpers";

const MODAL_NAME = "Fit_Information_Modal";
const propTypes = {
  browser: browserPropType.isRequired,
  displayedModal: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onClose: PropTypes.func.isRequired,
};

export class FitInformationModal extends React.Component {
  static MODAL_NAME = MODAL_NAME;
  static propTypes = propTypes;

  renderModalContent() {
    const { onClose } = this.props;

    return (
      <>
        <h3>
          We use millions of fit data
          <br />
          points you can count on
        </h3>

        {renderImportedImage(DataPlotOutline)}
        <p className="universal-medium semibold">Fit Feedback</p>
        <p className="universal-xsmall">
          Each time you provide details on how an item
          <br />
          fits, your style and size suggestions improve.
        </p>

        {renderImportedImage(StarOutline)}
        <p className="universal-medium semibold">Member Reviews</p>
        <p className="universal-xsmall">
          Members with similar Fit Profiles inform style
          <br />
          suggestions custom to you.
        </p>

        {renderImportedImage(TapeMeasureOutline)}
        <p className="universal-medium semibold">Your Fit Profile</p>
        <p className="universal-xsmall">
          Accurate measurements help to keep our tips
          <br />
          and tools up to date.{" "}
          <a className="universal-underline" href={User.Profile}>
            Update Fit Profile
          </a>
        </p>

        <AtomFullWidthButton onClick={onClose} buttonText="Got It" />
      </>
    );
  }

  render() {
    let additionalStyles = {};
    const {
      browser: { isMobileViewport },
      displayedModal,
      onClose,
    } = this.props;

    if (isMobileViewport) {
      additionalStyles = {
        content: {
          height: "100%",
          padding: "0 20px",
        },
      };
    }

    return (
      <ClosableModal
        isOpen={displayedModal === MODAL_NAME}
        optionalClass="modal-close-circle"
        optionalWrapperClass="recommended-fit-tag-modal"
        additionalStyles={additionalStyles}
        onRequestClose={onClose}>
        {this.renderModalContent()}
      </ClosableModal>
    );
  }
}

const mapStateToProps = state => {
  const { browser, displayedModal } = state;

  return {
    browser,
    displayedModal,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    onClose: () => dispatch(displayModal(false)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FitInformationModal);
